import { useEffect } from "react";
import Offcanvas from "bootstrap/js/dist/offcanvas";
import "./WelcomeModal.css";
import { useTranslation } from "react-i18next";
import LanguageSelector from "../../components/LanguageSelector/LanguageSelector";

export default function WelcomeOverlay({ open, onClose }) {
  const { t } = useTranslation();

  useEffect(() => {
    if (!open) return;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = prevOverflow);
  }, [open]);

  useEffect(() => {
    if (!open) return;
    const onKeyDown = (e) => {
      if (e.key === "Escape") {
        // onClose();
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, onClose]);

  if (!open) return null;

  const handleSignupClick = (e) => {
    e.preventDefault();
    onClose();
    requestAnimationFrame(() => {
      const el = document.getElementById("offcanvasRight");
      if (!el) return;
      Offcanvas.getOrCreateInstance(el).show();
    });
  };

  return (
    <div className="welcome-overlay">
      <div
        className="welcome-card bg-white shadow"
        role="dialog"
        aria-modal="true"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="d-flex align-items-center px-3 py-2 border-bottom">
          {/* SOL */}
          <div className="fw-semibold">
            {t("welcomeModal.title")}{" "}
            <span className="badge wbbgcolor align-middle ms-1 p-2 px-2">
              {t("welcomeModal.badge")}
            </span>
          </div>

          {/* SAĞ (dil + çarpı) */}
          <div className="ms-auto d-flex align-items-center gap-2">
            <LanguageSelector />
            <button
              type="button"
              className="btn-close flex-shrink-0"
              aria-label={t("common.close")}
              onClick={onClose}
            />
          </div>
        </div>

        <div className="p-3 px-4">
          <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center gap-4">
            <div className="discount-badge text-white text-center">
              <div className="discount-badge__percent">%10</div>
              <div className="discount-badge__label">
                {t("welcomeModal.discountLabel")}
              </div>
            </div>

            <div className="flex-grow-1">
              <div className="h5 mb-2 welcome-title">
                {t("welcomeModal.heading")}
              </div>

              <div className="text-muted mb-2 welcome-text">
                {t("welcomeModal.desc1")}{" "}
                <strong>{t("welcomeModal.descStrong")}</strong>{" "}
                {t("welcomeModal.desc2")}
                <br />
                <span className="text-muted">{t("welcomeModal.desc3")}</span>
              </div>

              <div className="small text-muted">{t("welcomeModal.note")}</div>
            </div>
          </div>

          <a
            href="/"
            className="btn w-100 mt-3 welcome-cta"
            onClick={handleSignupClick}
          >
            {t("welcomeModal.cta")}
          </a>
        </div>
      </div>
    </div>
  );
}
